import styled, { createGlobalStyle } from 'styled-components';

import ContentlyHelmet from './ContentlyHelmet';
import Plugins from 'components/plugins';
import ContentlyNav from './nav/nav';
import Footer from './footer/index';
import { Outlet } from 'react-router-dom';
import { Styles } from '../../toolkit/components/';
import { useFlashMessages } from '../../hooks/useFlashMessages';


const GlobalStyles = createGlobalStyle`
  html {
    font-weight:400;
    font-size: 14px;
    line-height: 22px;
    color: ${Styles.colors.black};
  }

  body {
    padding: 0;
    margin: 0;
    font-family: "Gotham A", "Gotham B", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  * {
    box-sizing: border-box;
  }
`;

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export default function Layout() {
  useFlashMessages();

  return (
    <>
      <ContentlyHelmet />
      <Plugins />
      <GlobalStyles />
      <ContentlyNav />
      <LayoutContainer>
        <Outlet />
      </LayoutContainer>
      <Footer />
    </>
  );
}
